import '../../CommonStyles.scss';
import './KpiCard.scss';
import { ReactNode } from 'react';
import SourceBadge from '../SourceBadge/SourceBadge';
import Paper from '@trackman/web-shared-components/components/Paper/Paper';

type DataSource = 'DB' | 'RECURLY' | 'LMS' | 'YOUTUBE' | 'GA4' | 'SALESFORCE';

interface KpiCardProps {
  label: string;
  source: DataSource;
  value: number | string;
  customClasses?: string;
  children?: ReactNode;
}

export const KpiCard = ({ label, source, value, customClasses, children }: KpiCardProps) => (
  <Paper className={`kpi-card ${customClasses || ''}`}>
    <div className='kpi-card-header'>
      <span className='kpi-label'>{label}</span>
      <SourceBadge source={source} />
    </div>
    <div className='kpi-value'>{value.toLocaleString()}</div>
    {children && <div className='kpi-meta'>{children}</div>}
  </Paper>
);

export default KpiCard;
